import cssSides, { Side } from '@team-griffin/css-sides';
import { gu2px, useTheme } from '@uds/theme-utils';
import { opacify } from '@ux/style-utils';
import longhand from '@team-griffin/css-longhand';
import { useStyles } from '@team-griffin/stylr';
import { useBreakpoints } from '@ux/responsive';

export default ({ isOdd, isLast }: { isOdd: boolean; isLast: boolean }) => {
  const {
    theme: { palette, spacing },
  } = useTheme();
  const { isMinLg } = useBreakpoints();
  return useStyles(
    {
      default: {
        tbodyRow: {
          display: 'flex',
          ...cssSides('padding', Side.Y, gu2px(2, spacing)),
          ...longhand('borderBottom', {
            width: 2,
            color: opacify(palette.grey06, 0.2),
            style: 'solid',
          }),
          backgroundColor: palette.grey12,
        },

        cell: {
          flex: 1,
          flexBasis: 0,
        },
      },

      isOdd: {
        tbodyRow: {
          backgroundColor: '#fff',
        },
      },

      isLast: {
        tbodyRow: {
          paddingBottom: gu2px(3, spacing),
          borderBottomWidth: 0,
        },
      },

      isMinLg: {
        tbodyRow: {
          ...cssSides('padding', Side.Y, gu2px(2, spacing)),
        },
      },

      isMinLgAndLast: {
        tbodyRow: {
          paddingBottom: gu2px(4, spacing),
        },
      },
    },
    [{ isOdd }, { isLast }, { isMinLg }, { isMinLgAndLast: isLast && isMinLg }],
  );
};
